const { feWp } = window;
const { doAction, applyFilters } = feWp.hooks;

const sliderDOMContentLoaded = () => {
  const breakpoints = applyFilters('b3rg_slider_breakpoints', {});

  const getCurrentBreakpoint = (resolution) => {
    for (const device in breakpoints) {
      if (resolution <= breakpoints[device]) {
        return device;
      }
    }
    return 'desktop'; // Default to desktop if no match is found
  };

  // eslint-disable-next-line no-undef
  let currentBreakpointVal = getCurrentBreakpoint(screen.width);

  // On page load
  doAction('b3rg_breakpoint_changed', currentBreakpointVal);

  // On page resize
  const handleOnResize = (entries) => {
    for (const entry of entries) {
      const { contentRect } = entry;
      const windowWidth = contentRect.width;
      const currentBreakpoint = getCurrentBreakpoint(windowWidth);

      if (currentBreakpointVal !== currentBreakpoint) {
        currentBreakpointVal = currentBreakpoint;
        doAction('b3rg_breakpoint_changed', currentBreakpoint);
      }
    }
  };

  // eslint-disable-next-line no-undef
  const resizeObserver = new ResizeObserver(handleOnResize);
  resizeObserver.observe(document.body);
};

document.addEventListener('DOMContentLoaded', sliderDOMContentLoaded);
